// extracted by mini-css-extract-plugin
module.exports = {"ActionBtns":"SessionDetails_ActionBtns__3HwW2"};